export const TV_VIEW_CODES = ['MAP', 'KPIS', 'QUEUE', 'CITIES', 'SERVICES'];
/** What the paired Painel TV calls, with its D561 device token (pairing itself is `DeviceApi.pair`). No operator session; a revoked or unknown token is
 * `401 DEVICE_TOKEN_INVALID` (back to the pairing screen); a view the panel does not show is `403 TV_VIEW_NOT_ENABLED`. */
export class TvPanelApi {
    client;
    constructor(client) {
        this.client = client;
    }
    get(path, token) {
        return this.client.request({ method: 'GET', path, headers: { authorization: `Bearer ${token}` } });
    }
    panel(token) {
        return this.get('/v1/device/tv/panel', token);
    }
    map(token) {
        return this.get('/v1/device/tv/map', token);
    }
    kpis(token) {
        return this.get('/v1/device/tv/kpis', token);
    }
    queue(token) {
        return this.get('/v1/device/tv/queue', token);
    }
    cities(token) {
        return this.get('/v1/device/tv/cities', token);
    }
    services(token) {
        return this.get('/v1/device/tv/services', token);
    }
}
//# sourceMappingURL=tv-panels.js.map